import { createContext } from 'react';
import type { ConversationHighlight } from '@/components/contacts/candidate-job-drawer/tabs/conversations/conversationHighlight';

export interface TransferredApplicationOverride {
  applicationData: any;
  refetchApplication: () => void;
}

/** What a surface inside the drawer may ask for when it sends the reader elsewhere. */
export interface GoToViewOptions {
  /** Scroll to this conversation and flash it once the tab has mounted. */
  highlightConversation?: ConversationHighlight;
}

export const CandidateContext = createContext({
  applicationId: '',
  applicationData: {},
  resourceUsage: null,
  modalRef: null,
  onContactLoaded: () => {},
  transferredStagesData: null as any,
  showAllStages: false,
  setShowAllStages: (_value: boolean) => {},
  transferredApplicationOverride: null as TransferredApplicationOverride | null,
  /**
   * Move the drawer to another tab — the slider owns `selectedItem`, and a section
   * several layers down (a stage activity, say) has no other way to reach it.
   *
   * Undefined outside the slider: the older drawer and the candidate profile render
   * some of the same components without providing this, so a caller falls back
   * rather than assuming it is there.
   */
  goToView: undefined as
    | ((_viewId: string, _options?: GoToViewOptions) => void)
    | undefined,
  /** Set by `goToView`, consumed once by the Conversations tab when it mounts. */
  pendingConversationHighlight: null as ConversationHighlight | null,
  clearConversationHighlight: () => {},
});
